/**
 * Dữ liệu chương trình tặng quà ngày Phụ nữ Việt Nam 20/10
 * Áp dụng: 17/10 - 21/10/2025
 */

export const WOMEN_20T10_TIME_FRAME = {
  start: new Date('2025-10-17T00:00:00+07:00'),
  end: new Date('2025-10-21T00:00:00+07:00')
}

export const WOMEN_20T10_MENUS = [
  {
    menu: 'Bánh 20/10',
    concept: 'Thiên nga',
    desc: 'Bánh kem thiên nga hồng - Pink Ombre Swan | Size nhỏ',
    sku: 'V9453',
    sparkleNeed: 0,
    giftName: 'card',
    B8: 1
  }
]
